<template>
  <div>
    <BackToTheTopArrow/>
    <div class="floral-bg-image"></div>
    <div class="center-container has-margin-top has-width">
      <silentbox-group class="flex-gallery"
                       :class="{ 'is-collapsed' : collapsed }">
        <silentbox-item v-for="image in OurWorkGallery"
                        :key="image.title"
                        :src="image.src"
                        :description="image.description"
                        class="flex-gallery__items">
          <img src="@/assets/icon_search.svg"
               alt="view icon"
               class="icon_view">
          <clazy-load :src="image.src">
            <transition name="fade" slot="image">
              <img :src="image.src"
                   alt="gallery image"
                   class="flex-gallery__items-figure">
            </transition>
            <transition name="fade" slot="placeholder">
              <div slot="placeholder">
                <lazy-load-spinner/>
              </div>
            </transition>
          </clazy-load>
        </silentbox-item>
      </silentbox-group>
      <div class="text-center">
        <button @click="seeMoreBtnText"
                type="button"
                aria-label="see more"
                class="btn btn-lg btn-primary">
          {{ seeMoreButton }}
        </button>
        <router-link :to="{name: 'OurWorkPageTwo'}" class="btn btn-lg btn-primary mx-3">
          Page 2
        </router-link>
        <router-link :to="{name: 'OurWork'}" class="btn btn-lg btn-primary">
          Go back
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import LazyLoadSpinner from '@/components/LazyLoaderSpinner'
import BackToTheTopArrow from '@/components/BackToTheTop'
import GalleryMixin from '@/mixins/gallery'
import OurWorkGallery from './ourworkpagethree.json'

export default {
  name: 'OurWorkPageThree',
  components: {
    LazyLoadSpinner,
    BackToTheTopArrow,
  },
  mixins: [GalleryMixin],
  data: () => ({
    OurWorkGallery,
  }),
  metaInfo: {
    title: 'Berries and Blooms - Our Work Page Three',
    links: [
      {
        rel: 'canonical',
        href: 'http://berriesandblooms.co.za/our-work-page-3',
      },
      {
        rel: 'alternate',
        href: 'http://berriesandblooms.co.za/our-work-page-3',
        hreflang: 'en-us',
      },
    ],
  },
}
</script>
